import { ofType } from 'redux-observable';
import { mergeMap, map, filter, switchMap, EMPTY, of } from 'rxjs';
import { AppEpic, AppState } from 'src/store';
import {
  inputIsNotNullOrUndefined,
  isScopeDefined,
  isWorklistActive,
  maybeGetComponentProps,
  topMemInUrl,
} from 'src/utils/Functions/epicsFunctions';
import { get, isEmpty } from 'lodash';
import { ConfDefnComponentType, EditableOverTimeGridComponent } from 'configuration-schemas/confdefnComponents';

import {
  fetchOverTimeData,
  updateSelectedItem,
  refreshOvertimeData,
  fetchCompanionData,
} from 'src/pages/AssortmentBuild/Pricing/PricingOverTime.slice';
import { receiveScopeRefreshTrigger } from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { fetchMassEditData } from 'src/pages/AssortmentBuild/Pricing/PricingOverTime.slice';
import { LENS_ASST_PLAN_REFRESHING_PAGE } from '../Planning.types';

function fetchTopMember(state: AppState, worklistSelectedItem?: string): string {
  const flowSheetSelectedItem = !isEmpty(state.pages.assortmentBuild.pricing.selectedItem)
    ? state.pages.assortmentBuild.pricing.selectedItem
    : null;
  const worklistItem = worklistSelectedItem;
  const urlTopMember = topMemInUrl();
  return flowSheetSelectedItem ?? worklistItem ?? urlTopMember ?? '';
}

export const pricingOverTimeLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(updateSelectedItem.type, LENS_ASST_PLAN_REFRESHING_PAGE, refreshOvertimeData.type),
    filter((action) => {
      if (action.type === updateSelectedItem.type && isEmpty(action.payload)) {
        return false;
      }
      return true;
    }),
    map(
      () =>
        maybeGetComponentProps<EditableOverTimeGridComponent>(state$.value, ConfDefnComponentType.pricing) ??
        maybeGetComponentProps<EditableOverTimeGridComponent>(state$.value, 'pricing' as ConfDefnComponentType),
    ),
    filter(inputIsNotNullOrUndefined),
    filter(() => isScopeDefined(state$.value.scope)),
    mergeMap((componentProps) => {
      const { topMembers } = componentProps;
      const currentSelectedItem = fetchTopMember(state$.value, topMembers);

      if (isEmpty(currentSelectedItem)) {
        return EMPTY;
      }

      // we allow a third element to be passed in from `componentProps.defns.models` in flowsheet/pricing,
      // to override the modeldefn, in order to support different pivot runs
      const maybeThirdModel = get(componentProps, 'defns.models[2]', undefined);
      return of(fetchOverTimeData(currentSelectedItem, maybeThirdModel));
    }),
  );
};

export const pricingOvertimeCompanionLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(receiveScopeRefreshTrigger.type, LENS_ASST_PLAN_REFRESHING_PAGE, receiveFilterStateAfterSubmission.type),
    map(() => maybeGetComponentProps<EditableOverTimeGridComponent>(state$.value, ConfDefnComponentType.pricing)),
    filter(inputIsNotNullOrUndefined),
    filter(() => !isWorklistActive(state$.value)),
    filter(() => isScopeDefined(state$.value.scope)),
    switchMap(({ defns, hideCompanion }) => {
      if (hideCompanion) {
        return of(refreshOvertimeData());
      }

      const companionModel = defns.models[0];
      const massEditModel = defns.models[1];
      const actions = [
        ...(companionModel ? [fetchCompanionData(companionModel)] : []),
        ...(massEditModel ? [fetchMassEditData(massEditModel)] : []),
      ];

      return of(...actions);
    }),
  );
};
